import { rootApi } from "../rootApi";
import { IPaginationResponse } from "../types";
import {
  IAdditionalMailingRequest,
  IAdditionalMailingRequestsParams,
  IAdditionalMailingRequestParams,
  IAdditionalMailingRequestPayload,
} from "./types";

export const additionalMailingRequestApis = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    additionalMailingRequests: builder.query<
      IPaginationResponse<IAdditionalMailingRequest>,
      IAdditionalMailingRequestsParams
    >({
      query: ({ proxyEventId }) => ({
        url: `proxy-events/${proxyEventId}/additional-mailing-requests/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "additionalMailingRequests", id: arg.proxyEventId },
      ],
    }),
    additionalMailingRequest: builder.query<
      IAdditionalMailingRequest,
      IAdditionalMailingRequestParams
    >({
      query: ({ proxyEventId, id }) => ({
        url: `proxy-events/${proxyEventId}/additional-mailing-requests/${id}/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "additionalMailingRequests", id: arg.id },
      ],
    }),
    createAdditionalMailingRequest: builder.mutation<
      IAdditionalMailingRequest,
      { proxyEventId: string; payload: IAdditionalMailingRequestPayload }
    >({
      query: ({ proxyEventId, payload }) => ({
        url: `proxy-events/${proxyEventId}/additional-mailing-requests/`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (_result, _, arg) => [
        { type: "additionalMailingRequests", id: arg.proxyEventId },
      ],
    }),
    updateAdditionalMailingRequest: builder.mutation<
      IAdditionalMailingRequest,
      {
        proxyEventId: string;
        id: string;
        payload: IAdditionalMailingRequestPayload;
      }
    >({
      query: ({ proxyEventId, id, payload }) => ({
        url: `proxy-events/${proxyEventId}/additional-mailing-requests/${id}/`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: (_result, _, arg) => [
        { type: "additionalMailingRequests", id: arg.proxyEventId },
      ],
    }),
    deleteAdditionalMailingRequest: builder.mutation<
      void,
      { proxyEventId: string; id: string }
    >({
      query: ({ proxyEventId, id }) => ({
        url: `proxy-events/${proxyEventId}/additional-mailing-requests/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _, arg) => [
        { type: "additionalMailingRequests", id: arg.proxyEventId },
      ],
    }),
  }),
});

export const {
  useAdditionalMailingRequestsQuery,
  useAdditionalMailingRequestQuery,
  useCreateAdditionalMailingRequestMutation,
  useUpdateAdditionalMailingRequestMutation,
  useDeleteAdditionalMailingRequestMutation,
} = additionalMailingRequestApis;
